var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18182 4.74359H5.27273M7.45455 4.74359H8.54545M10.7273 4.74359H11.8182M4.18182 11.2704H5.27273M7.45455 11.2704H8.54545M10.7273 11.2704H11.8182M5.81818 1.00093V1.01399C5.81818 1.50856 6.04805 1.98288 6.45722 2.3326C6.86639 2.68232 7.42135 2.87879 8 2.87879C8.57865 2.87879 9.13361 2.68232 9.54278 2.3326C9.95195 1.98288 10.1818 1.50856 10.1818 1.01399L10.1807 1H12.9091C13.1984 1 13.4759 1.09823 13.6805 1.27309C13.8851 1.44795 14 1.68511 14 1.9324V14.0676C14 14.3149 13.8851 14.552 13.6805 14.7269C13.4759 14.9018 13.1984 15 12.9091 15H10.1818C10.1818 14.5054 9.95195 14.0311 9.54278 13.6814C9.13361 13.3317 8.57865 13.1352 8 13.1352C7.42135 13.1352 6.86639 13.3317 6.45722 13.6814C6.04805 14.0311 5.81818 14.5054 5.81818 15H3.09091C2.80158 15 2.52411 14.9018 2.31952 14.7269C2.11493 14.552 2 14.3149 2 14.0676V1.9324C2 1.68511 2.11493 1.44795 2.31952 1.27309C2.52411 1.09823 2.80158 1 3.09091 1L5.81818 1.00093Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicket);
export default __webpack_public_path__ + "static/media/icon-ticket.7d3ff91fd062654805e369193228f207.svg";
export { ForwardRef as ReactComponent };